import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaArrowRight, FaCheck } from 'react-icons/fa';
import { formatTitleWithBreak } from '../../utils';



const Plan = ({ plan }) => {

  const { icon, image, title, price, features } = plan; // Extracting data from plan

  return (
    <div className="plan-item">

      <img src={image} alt={title} />

      <div className='plan-content'>

        <div className='intro'>
          <h3><span>{formatTitleWithBreak(title)}</span></h3> {/* Plan Title */}
          <div className='top-icon'>{icon}</div> {/* Dynamic Icon */}
        </div>

        <div className="price">${price} <span>/ month</span></div> {/* Plan Price */}

        <div className='content'>

          {/* List of Features */}
          <ul>
            {features.map((feature, index) => (
              <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
            ))}
          </ul>

          <Button link={"Contact-us"} title={"Get Started"} icon={FaArrowRight} />

        </div>

      </div>

    </div>
  );
};

export default Plan;